export default __webpack_public_path__ + "static/media/terminoliesIconLight.0e8842b7.svg";